import { Fragment, useEffect, useRef } from 'react';
import { Label, OverlayTrigger } from 'react-bootstrap';
import PopoverTemplate from '@nkr/components/popover-template';
import { ICenterBillingReport } from '@nkr/models/index';

interface IProps {
    data: ICenterBillingReport
}

export const SerologyBillable = ({ data }: IProps) => {
    const triggerRef = useRef<any>(null);

    useEffect(() => {
        const close = () => triggerRef.current?.hide();
        window.addEventListener('scroll', close, { capture: true, passive: true });
        return () => window.removeEventListener('scroll', close, { capture: true } as any);
    }, []);

    const details = [
        { label: 'Is Internal', value: data.isInternal ? 'Yes' : 'No' },
        { label: 'Serology Requested', value: data.serologyRequestedDateTime },
        { label: 'Serology Shipped', value: data.serologyShippedDateTime },
        { label: 'Serology Completed', value: data.serologyCompleteDateTime },
    ];

    const overlay = (
        <PopoverTemplate>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content', columnGap: 15, rowGap: 3, whiteSpace: 'nowrap', color: 'black' }}>
                {details.map(({ label, value }) => (
                    <Fragment key={label}>
                        <strong>{label}:</strong>
                        <span style={{ textAlign: 'right' }}>{value || '--'}</span>
                    </Fragment>
                ))}
            </div>
        </PopoverTemplate>
    );

    return (
        <OverlayTrigger ref={triggerRef} trigger='click' placement='bottom' rootClose overlay={overlay}>
            <Label bsStyle={data.serologyIsBillable ? 'success' : 'default'} style={{ fontSize: '100%', cursor: 'pointer' }}>
                {data.serologyIsBillable ? 'Y' : 'N'}
            </Label>
        </OverlayTrigger>
    );
};
